export type CollectionDownloadStatus =
  | "not_downloaded"
  | "downloading"
  | "downloaded";

export type CollectionDownloadProgress = {
  downloadedTracks: number;
  progress: number;
  status: CollectionDownloadStatus;
  totalTracks: number;
};

const emptyProgress: CollectionDownloadProgress = {
  downloadedTracks: 0,
  progress: 0,
  status: "not_downloaded",
  totalTracks: 0,
};

// Web version - no SQLite, downloads are not supported.
export const useDownloadProgressDetails = () => emptyProgress;

export const useDownloadProgress = () => emptyProgress.status;
